import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

//const CALENDARIOPATH = 'https://www.extranet.ceuma.br/ceuma-wordpress//wp-json/wp/v2/documentos?_embed=true&per_page=15&filter%5Bdocument_type%5D=calendario-academico';


@Injectable({
  providedIn: 'root'
})
export class CalendarioService {

  public requestURL = environment.calendarioAcademicoURLWP

  constructor(private http: HttpClient) { }

  recuperarUrlCalendario(): Observable<any>{
    return this.http.get(this.requestURL);
  }

}
